// Form2PartA.jsx
import React, { useEffect, useState } from "react";
import ABTextEdu from "../../Common/ABTextEdu";
import Checkbox from "../../../UI_Design/FormComponents/CheckboxAndLabel/Checkbox";
import EMPDate from "../../EmploymentForm/empDate";
import { useDispatch, useSelector } from "react-redux";
import QualificationDropdown from "../../DiyDigilockerNonIBridge/Dropdown";
import { useNavigate, useParams } from "react-router-dom";
import TextField from "./textField";
import RadioButtonGroup from "../../../UI_Design/FormComponents/RadioAndLabel/RadioButtonGroup";
import { SaveOnboardingDetails } from "../../../Actions/onboardingDetailsAction";
import { toast } from "react-toastify";
import Loader from "../../Common/loader";

const Form2PartA = ({
  tab,
  tabArr,
  tabId,
  nomineeArray,
  referenceNo,
  showProfilePreview,
  caseCheckId,
  index,
  allDisabled,
  otherInstituteObj,
}) => {
  let url = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isChecked, setIsChecked] = useState(false);
  // const [nominees, setNominees] = useState([{ id: 1, name: '', relationship: '', dob: '', address: '', sharePercentage: '', isMinor: false, guardianName: '', guardianAddress: '' }]);
  const [nominees, setNominees] = useState([]);
  const [isInternationalWorker, setIsInternationalWorker] = useState(null);
  const [nomineeCount, setNomineeCount] = useState(1);
  const [allNomineeFields, setAllNomineeFields] = useState({});

  const [EpfData, setEpfData] = useState([]);
  const [val, setVal] = useState({});
  const [prevTab, setPrevTab] = useState("");
  const [nextTab, setNextTab] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const storeOnboardingData = useSelector((state) => state.onboardingDetail);
  const { onboardingDetailData, loading, error } = storeOnboardingData;

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  useEffect(() => {
    window.scrollTo(0,0)
  }, []);

  useEffect(() => {
    if (
      typeof onboardingDetailData !== "undefined" &&
      onboardingDetailData !== null
    ) {
      // setEpfData(onboardingDetailData?.data?.tabDetails["EPS Nomination"]?.field_details);
      setEpfData(tab);
      if(nomineeArray?.[tabId]){
        setNominees(nomineeArray?.[tabId]);
      }else{
        setNominees([tab?.["PF Nominee Details"]?.field_details]);
      }
      setAllNomineeFields(tab?.["PF Nominee Details"]?.field_details);

      // debugger
      // let newNominee =  [...tab?.["PF Nominee Details"]?.field_details];
      // newNominee.map((item,idx) => {
      //   item.id = `${item?.id}-${idx}`;
      // })
      // setNominees([newNominee]);

      let newData = { ...tab };

      // setting up all prefilled values

      newData &&
        Object.entries(newData).map(([key, item], idx) => {
          item?.field_details.map((field) => {
            setVal((prev) => ({
              ...prev,
              [field?.slug]: field?.value,
            }));
          });
        });

      // finding out next and prev tab

      let currTabIdx = "";
      Object.entries(tabArr).map(([item, id], index) => {
        if (id == tabId) {
          currTabIdx = index;
        }
      });
      let prevTab, nextTab;
      let allTabs = Object.keys(tabArr);
      if (currTabIdx > 0) {
        // prevTab = allTabs[currTabIdx-1];
        setPrevTab(allTabs[currTabIdx - 1]);
      }
      if (currTabIdx <= allTabs.length - 1) {
        // nextTab = allTabs[currTabIdx+1];
        // setNextTab(nextTab)
        setNextTab(allTabs[currTabIdx + 1]);
      }
    }
  }, [onboardingDetailData, storeOnboardingData, url]);

  const handleCheckboxChange = (checked, name, id, err_id) => {
    setIsChecked(checked);
    console.log("Checkbox is now:", checked);
    setVal((prev) => ({
      ...prev,
      [name]: checked,
    }));
    let errorTag = document.getElementById(err_id);
    errorTag.innerHTML = "";
  };

  const handleAddNominee = () => {
    if (nominees.length < 2) {
      // setNominees([...nominees, { id: nominees.length + 1 }]);
      // setNominees((prev) => ([
      //   ...prev,
      //   [nominees.length] : tab?.['PF Nominee Details']?.field_details
      // ]))
      // let newNominee = [...nominees];
      // // let addedNominee = {...tab?.["PF Nominee Details"]};
      // let addedNominee = [...allNomineeFields]; 
      // addedNominee.map((item) => {
      //   item.value = ''
      // })
      // newNominee.push(tab?.["PF Nominee Details"]?.field_details);
      // newNominee[newNominee.length - 1].map((item) => {
      //   item.value = ''
      // })

      // const addedNominee = allNomineeFields.map((item) => {
      //   if(item.slug == 'nominee_guardian_name' || item.slug == 'nominee_guardian_address'){
      //     item.is_visible = '0'
      //     item.value = ''
      //   }else{
      //     item.is_visible = '1'
      //     item.value = ''
      //   }
      //   return item;
      //   });

      const addedNominee = allNomineeFields.map(item => ({
          ...item,
          is_visible : item.slug == 'nominee_guardian_name' || item.slug == 'nominee_guardian_address' || item?.slug == "nominee_guardian_relationship" ? '0' : '1',
          value: '' 
      }));

      // Create a new array of nominees including the new nominee
      const newNominee = [...nominees, addedNominee];
      // newNominee.push(addedNominee);
      setNominees(newNominee);
      // let newNominee = [...nominees];
      // // newNominee.push(tab?.["PF Nominee Details"]?.field_details);
      // newNominee.push(allNomineeFields);
      // setNominees(newNominee);
    }
  };

  const handleRemoveNominee = (id) => {
    if (nominees.length > 1) {
      // setNominees(nominees.filter(nominee => nominee.id !== id));
      let updatedNominee = [...nominees];
      // delete updatedNominee[id];
      // const newArr = updatedNominee.splice(1, 1);
      updatedNominee.pop();
      // console.log(newArr);
      setNominees(updatedNominee);
    }
  };

  const handleInputChange = (index, field, value) => {
    const updatedNominees = nominees.map((nominee, i) =>
      i === index ? { ...nominee, [field]: value } : nominee
    );
    setNominees(updatedNominees);
  };

  const handleDropdownChange = (value) => {
    // console.log(`Selected value: ${event.target.value}`);
    // Implement your dropdown change logic here
    setVal((prev) => ({
      ...prev,
      [value[0].name]: value[0].value,
    }));
    let errorTag = document.getElementById(value?.[0]?.err_id);
    errorTag.innerHTML = "";
    if(value[0].name == 'nominee_relationship' || value[0]?.name == 'nominee_guardian_relationship'){
      let newNominee = [...nominees];
      newNominee[value[0].nomineeIndex][value[0].nomineeFieldIdx].value = value[0].value;
      setNominees(newNominee);
    }else{
      setVal((prev) => ({
        ...prev,
        [value[0].name]: value[0].value,
      }));
    }
  };

  const textHandler = (value) => {

    let errorTag = document.getElementById(value?.[0]?.err_id);
    errorTag.innerHTML = "";
    if (
      value[0].name == "nominee_address" ||
      value[0].name == "nominee_name" ||
      value[0].name == "nominee_amount_share" ||
      value[0].name == "nominee_guardian_name" ||
      value[0].name == "nominee_guardian_address"
    ) {
      let newNominee = [...nominees];
      // newNominee.map(nominee)
      // Object.values(newNominee[value[0].nomineeIndex]).map((nom, idx) => {
      //   if (nom.slug == value[0].name) {
      //     nom.value = value[0].value;
      //   }
      // });
      // newNominee[value[0].nomineeIndex][value[0].nomineeFieldIdx].value = value[0].value;
      // if(isNomineeAdult(newdate)){
      //   Object.values(newNominee[nomIdx]).map((nom,idx) => {
      //   if(nom.slug == 'nominee_guardian_name' || nom?.slug == 'nominee_guardian_address'){
      //     nom.is_visible = '0';
      //     nom.value = ''
      //     setVal((prev)=>({
      //       ...prev,
      //       [nom?.slug] : ''
      //     }))
      //   }
      // })
      // }else{
      //   Object.values(newNominee[nomIdx]).map((nom,idx) => {
      //     if(nom.slug == 'nominee_guardian_name' || nom?.slug == 'nominee_guardian_address'){
      //       nom.is_visible = '1';
      //     }
      //   })
      // }
      newNominee[value[0].nomineeIndex][value[0].nomineeFieldIdx].value = value[0].value;
      console.log(newNominee);
      setNominees(newNominee);
    }else{
      setVal((prev) => ({
        ...prev,
        [`${value[0].name}`]: value[0].value,
      }));
    }
  };

  const handleBack = (e) => {
    e.preventDefault();
    // navigate(`/onbordingDetailsInstaform/${prevTab.replaceAll(" ", "_")}`);
    navigate(`/case-initiation/check-detail/${referenceNo}/11/${prevTab.replaceAll(" ", "_")}`)
  };

  const saveHandler = (e) => {
    e.preventDefault();
    let err = formValidation();
    // let err = false;
    console.log(err);
    if (err) {
      toast.dismiss();
      let msg = "Please fill all required fields"
      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsLoading(false)
    } else {
      // api call
        setIsLoading(true)
        let allNomineeFields1 = [
          "nominee_name",
          "nominee_address",
          "nominee_amount_share",
          "nominee_guardian_name",
          "nominee_guardian_address",
          "nominee_relationship",
          "nominee_dob",
          "nominee_guardian_relationship"
        ];


      let nomineeObj = transformNominees(nominees, allNomineeFields1);
      console.log(nomineeObj)
      let totalShare = 0
      nomineeObj['nominee_amount_share'].map((share) => {totalShare = totalShare + parseInt(share)});
      console.log(totalShare);
      if(totalShare != 100){
        let msg = "PF nominee amount share does not add upto 100%"
        toast.error(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setIsLoading(false)
        return;
        }
      // }

      let obj = {
        tab_id: tabId,
        customfields_data: { ...val, ...nomineeObj },
        pfNomineeFields : { [tabId] : [...nominees]}
      };
      console.log(obj)
      dispatch(SaveOnboardingDetails(obj, saveCallback));
    }
  };

  // const saveCallback = (data) => {
  //   // next tab redirection
  //   debugger
  //   if (nextTab && data?.group == "")
  //     navigate(`/onbordingDetailsInstaform/${nextTab.replaceAll(" ", "_")}`);
  // };

  const saveCallback = (data) => {
    // next tab redirection
    if (data?.group?.group_id != "profile_preview"){
      if(nextTab){
        navigate(`/case-initiation/check-detail/${referenceNo}/11/${nextTab.replaceAll(" ", "_")}`)
      }else{
        navigate(`/case-initiation/check-detail/${referenceNo}/11/${data?.group?.group_id.replaceAll(" ", "_")}`)
      }
      // navigate(`/onbordingDetailsInstaform/${nextTab.replaceAll(" ", "_")}`);
    }else{
      if(data?.group?.group_id == "profile_preview"){
        // let reference = 17521721385945
        navigate(`/case-initiation/profile-preview/${referenceNo}`);
      }
    }
    setIsLoading(false);
  };

  const handleSubmitForPreview = () => {
    navigate(`/case-initiation/profile-preview/${referenceNo}`);
  }


  const transformNominees = (nomineesArray, fieldList) => {
    const result = {};
  
    nomineesArray.forEach(nomineeList => {
      nomineeList.forEach(nominee => {
        const { slug, value } = nominee;
        if(fieldList.includes(slug)){
          if (!result[slug]) {
            result[slug] = [];
          }
          result[slug].push(value);
        }
      });
    });
  
    return result;
  };

  const formValidation = (e) => {
    let err = false;
  
    EpfData && Object.entries(EpfData).forEach(([key, valObj]) => {
      if(key != 'PF Nominee Details'){
        valObj?.field_details.forEach((value) => {
            if (value && value?.is_mandatory == "1" && value?.is_visible == "1") {
                let fieldValue 
                let errorTag = document.getElementById(`${value?.slug}-${value?.id}`);
                if (value?.validation_type == 'custom' && value?.validation) {
                  fieldValue = val?.[value?.slug]
                    if (!fieldValue || !new RegExp(value?.validation).test(fieldValue)) {
                        err = true;
                        if (errorTag) {
                            if(value?.validation_msg){
                              errorTag.innerHTML = value?.validation_msg;  
                            }else if(val?.[value?.slug]?.trim() == ''){
                              errorTag.innerHTML = 'This field is required.';
                            }else{
                              errorTag.innerHTML = "Please provide a valid input." 
                            }
  
                        }
                    } else {
                        if (errorTag) {
                            errorTag.innerHTML = '';
                        }
                    }
                } else {
                  fieldValue = val?.[value?.slug]
                  console.log(fieldValue, 'errrrrr');
                    if (!fieldValue || val?.input_type == 1 ? fieldValue.trim() === '' : fieldValue === '') {
                        err = true;
                        if (errorTag) {
                            // errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : 'This field is required.';
                            // errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : val?.[value?.slug]?.[0]?.trim() == '' ? 'This field is required.' : "Please provide a valid input." 
                            if(value?.validation_msg){
                              errorTag.innerHTML = value?.validation_msg;  
                            }else if(val?.[value?.slug]?.trim() == ''){
                              errorTag.innerHTML = 'This field is required.';
                            }else{
                              errorTag.innerHTML = "Please provide a valid input." 
                            }
  
                        }
                    } else {
                        if (errorTag) {
                            errorTag.innerHTML = '';
                        }
                    }
                }
            }
        });
      }  
    });

    nominees && nominees.map((valObj,index) => {
      valObj?.forEach((value) => {
          if (value && value?.is_mandatory == "1" && value?.is_visible == "1") {
              let fieldValue 
              let errorTag = document.getElementById(`${value?.slug}-${value?.id}-${index}`);
              if (value?.validation_type == 'custom' && value?.validation) {
                fieldValue = value?.value;
                if (!fieldValue || !new RegExp(value?.validation).test(fieldValue)) {
                    console.log(fieldValue, 'errrrrr');
                      err = true;
                      if (errorTag) {
                          if(value?.validation_msg){
                            errorTag.innerHTML = value?.validation_msg;  
                          }else if(value?.value?.trim() == ''){
                            errorTag.innerHTML = 'This field is required.';
                          }else{
                            errorTag.innerHTML = "Please provide a valid input." 
                          }

                      }
                  } else {
                      if (errorTag) {
                          errorTag.innerHTML = '';
                      }
                  }
              } else {
                fieldValue = value?.value;
                if (!fieldValue || val?.input_type == 1 ? fieldValue.trim() === '' : fieldValue === '') {
                    console.log(fieldValue, 'errrrrr');
                      err = true;
                      if (errorTag) {
                          // errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : 'This field is required.';
                          // errorTag.innerHTML = value?.validation_msg ? value?.validation_msg : val?.[value?.slug]?.[0]?.trim() == '' ? 'This field is required.' : "Please provide a valid input." 
                          if(value?.validation_msg){
                            errorTag.innerHTML = value?.validation_msg;  
                          }else if(value?.value?.trim() == ''){
                            errorTag.innerHTML = 'This field is required.';
                          }else{
                            errorTag.innerHTML = "Please provide a valid input." 
                          }

                      }
                  } else {
                      if (errorTag) {
                          errorTag.innerHTML = '';
                      }
                  }
              }
          }
      });
  });
  
    return err;
  };
  

  // const formValidation = (e) => {
  //   let err = false;

  //   // EpfData && EpfData.map((value, index) => {
  //   EpfData &&
  //     Object.entries(EpfData).map(([key, valObj], idx) => {
  //       if (key != "PF Nominee Details") {
  //         {
  //           valObj?.field_details.map((value, index) => {
  //             if (
  //               value &&
  //               value?.is_mandatory == "1" &&
  //               value?.is_visible == "1"
  //             ) {
  //               if (value?.validation_type == "custom" && value?.validation) {
  //                 err = matchRegex(value?.validation, val?.[value?.slug]);
  //                 if (err || !val?.[value?.slug]?.[0]?.trim()) {
  //                   let errorTag = document.getElementById(
  //                     `${value?.slug}-${value?.id}`
  //                   );
  //                   console.log(errorTag, "err", value?.label);
  //                   errorTag.innerHTML = value?.validation_msg
  //                     ? value?.validation_msg
  //                     : "This field is required.";
  //                 }
  //               } else {
  //                 if (!val?.[value?.slug] || val[value?.slug].trim() == "") {
  //                   err = true;
  //                   let errorTag = document.getElementById(
  //                     `${value?.slug}-${value?.id}`
  //                   );
  //                   console.log(errorTag, "err", value?.label);
  //                   errorTag.innerHTML = value?.validation_msg
  //                     ? value?.validation_msg
  //                     : "This field is required.";
  //                 }
  //                 // if( val.input_type == 4 )
  //               }
  //             }
  //           });
  //         }
  //       }
  //     });

  //   // check nominee fields validation

  //   nominees.map((nominee, index) => {
  //     nominee.map((value, idx) => {
  //       if (value && value?.is_mandatory == "1" && value?.is_visible == "1") {
  //         if (value?.validation_type == "custom" && value?.validation) {
  //           err = matchRegex(value?.validation, value?.value);
  //           if (err || !value?.value?.[0]?.trim()) {
  //             let errorTag = document.getElementById(
  //               `${value?.slug}-${value?.id}-${index}`
  //             );
  //             console.log(errorTag, "err", value?.label);
  //             errorTag.innerHTML = value?.validation_msg
  //               ? value?.validation_msg
  //               : "This field is required.";
  //           }
  //         } else {
  //           if (!value?.value || value?.value == "") {
  //             err = true;
  //             let errorTag = document.getElementById(
  //               `${value?.slug}-${value?.id}-${index}`
  //             );
  //             console.log(errorTag, "err", value?.label);
  //             errorTag.innerHTML = value?.validation_msg
  //               ? value?.validation_msg
  //               : "This field is required.";
  //           }
  //           // if( val.input_type == 4 )
  //         }
  //       }
  //     });
  //   });

  //   return err;
  // };

  function matchRegex(reg, value) {
    const regex = new RegExp(reg);
    return regex.test(value);
  }

  // const saveDateHandler = (checkDetailsIndex, fieldName, date) => {
  //   console.log(`Date saved: ${date}`);
  //   // Implement your date saving logic here

  // };

  const saveDateHandler = (
    checkDetailsIndex,
    fieldName,
    date,
    name,
    err_id,
    nomIdx,
    nomFieldIdx
  ) => {
    console.log(`Date saved: ${date}`);

    // let dob = new Date(date);
    let newdate = date;

    if (name == "nominee_dob") {
      let newNominee = [...nominees];
      // newNominee.map(nominee)
      // Object.values(newNominee[nomIdx]).map((nom,idx) => {
      // if(nom.slug == 'nominee_dob'){
      // nom.value = date.split('/').join('-');
      // }
      // })
      if (isNomineeAdult(newdate)) {
        Object.values(newNominee[nomIdx]).map((nom, idx) => {
          if (
            nom.slug == "nominee_guardian_name" ||
            nom?.slug == "nominee_guardian_address" || nom?.slug == "nominee_guardian_relationship"
          ) {
            nom.is_visible = "0";
            nom.value = "";
            setVal((prev) => ({
              ...prev,
              [nom?.slug]: "",
            }));
          }
        });
      } else {
        Object.values(newNominee[nomIdx]).map((nom, idx) => {
          if (
            nom.slug == "nominee_guardian_name" ||
            nom?.slug == "nominee_guardian_address" || nom?.slug == "nominee_guardian_relationship"
          ) {
            nom.is_visible = "1";
          }
        });
      }
      newNominee[nomIdx][nomFieldIdx].value = date.split("/").join("-");
      console.log(newNominee);
      setNominees(newNominee);
    }else{
      setVal((prev) => ({
        ...prev,
        [name]: date.split("/").join("-"),
      }));
    }
    let errorTag = document.getElementById(err_id);
    errorTag.innerHTML = "";
    // Implement your date saving logic here
  };

  const isNomineeAdult = (date) => {
    const today = new Date();
    const [dd, mm, yyyy] = date.split("-");
    const dob = new Date(`${yyyy}/${mm}/${dd}/`);
    if (dob !== "Invalid date") {
      const age = today.getFullYear() - dob.getFullYear();
      const monthDiff = today.getMonth() - dob.getMonth();
      const dayDiff = today.getDate() - dob.getDate();

      if (age > 18) {
        return true;
      } else if (age === 18) {
        if (monthDiff > 0) {
          return true;
        } else if (monthDiff === 0) {
          return dayDiff >= 0;
        }
      }

      return false;
    }
  };

  const handleRadioButtonChange = (index) => {
    setIsInternationalWorker(index === 0); // Assuming "Yes" is the first option
  };

  console.log(nominees, "nom"); 
  console.log(val, 'valllll') 

  return (
    <>
    {isLoading && <Loader></Loader>}
      <>
        <div className="d-block row my-3 pr-5">
          {EpfData &&
            Object.entries(EpfData).map(([key, value], idx) => {
              console.log(key, "-->", value);
              return (
                <>
                  {key == "PF Nominee Details" ? (
                    <>
                      <div className="border-top">
                        <h4 className="py-4 " style={{ fontWeight: "bold", fontSize: 'larger' }}>
                          PART-A (EPF)
                        </h4>
                      </div>

                    </>
                  ) : null}
                  <h4 className="pb-2 " style={{ fontWeight: "bold", fontSize: 'larger' }}>
                    {key}
                  </h4>
                  {key == "Form 2" && (
                    <div className="mb-4">
                      <small className="pb-2">
                        Form 2 in EPFO (Employees' Provident Fund Organization)
                        is a self-declaration form that individuals need to fill
                        when joining an organization covered under the EPF Scheme,
                        1952 and/or EPS, 1995.
                      </small>
                    </div>
                  )}
                  <div className="d-flex row mt-2">
                    {value?.field_details.map((item, index) => {
                      // textField
                      if (
                        item.input_type == 1 &&
                        item?.is_visible &&
                        key != "PF Nominee Details"
                      ) {
                        return (
                          <>
                            <TextField
                              label={item?.label}
                              name={item?.slug}
                              id={item?.id}
                              fieldId="spouseNameField"
                              isRequired={item?.is_mandatory}
                              // errId="spouseNameError"
                              caseId={caseCheckId}
                              divClass="col-lg-4 col-md-6 col-sm-12"
                              value={item?.value || val[item?.slug] || ""}
                              caseCheckId={caseCheckId}
                              drugIndex={index}
                              checkDetailsIndex={index}
                              fieldName="spouseName"
                              customError={false}
                              isDisabled={allDisabled}
                              index={index}
                              collegeOther={otherInstituteObj}
                              inputText={textHandler}
                              labelStyle={{ color: "#6B7280" }}
                              errId={`${item?.slug}-${item?.id}`}
                            />
                          </>
                        );
                      }
                      // dropdown
                      if (
                        item.input_type == 4 &&
                        item?.is_visible &&
                        key != "PF Nominee Details"
                      ) {
                        return (
                          <div className="col-lg-4 col-md-6 col-sm-12">
                            <QualificationDropdown
                              // label="Marital Status"
                              label={item?.label}
                              labelStyle={{ color: "#6B7280" }}
                              // options={["Married", "Single", "Divorced", "Widowed", "Separated", "Other"]}
                              options={item.options}
                              onChange={handleDropdownChange}
                              errId={`${item?.slug}-${item?.id}`}
                              value={ val[item?.slug] || item?.value}
                              // value={val?.value || }
                              name={item?.slug}
                              id={item?.id}
                              isRequired={
                                item?.is_mandatory == "1" ? true : false
                              }
                            />
                          </div>
                        );
                      }
                      // date field
                      if (
                        item.input_type == 7 &&
                        item?.is_visible &&
                        key != "PF Nominee Details"
                      ) {
                        return (
                          <EMPDate
                            placeholder={item?.label}
                            name={item?.slug}
                            id={item?.id}
                            fieldId="dateOfJoiningField"
                            paramStartDate=""
                            checkDetailsIndex={index}
                            fieldName="company_date_joining"
                            fieldType='Onboarding'
                            // errId="dateOfJoiningError"
                            isRequired={item?.is_mandatory == "1" ? true : false}
                            saveDate={saveDateHandler}
                            isDisabled={allDisabled}
                            checkID={58} // Example checkID, adjust according to your logic
                            minDateDOL={null}
                            maxDOJDate={null}
                            divClass="col-lg-4 col-md-6 col-sm-12"
                            placeholderStyle={{
                              color: "#6B7280",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            errId={`${item?.slug}-${item?.id}`}
                            customError={false}
                          />
                        );
                      }
                      // Radio button
                      if (
                        item.input_type == 5 &&
                        item?.is_visible == "1" &&
                        key != "PF Nominee Details"
                      ) {
                        return (
                          <>
                            <div className="col-12 mb-4">
                              <div
                                className="d-flex"
                                style={{ alignItems: "center" }}
                              >
                                <h1 className="tabsContentHead">
                                  {item?.label}
                                </h1>
                                {item?.is_mandatory == 1 && (
                                  <sup className="text-danger"> *</sup>
                                )}
                              </div>

                              <RadioButtonGroup
                                options={
                                  Object.entries(item.options).map(
                                    ([key, value]) => {
                                      return value;
                                    }
                                  ) || ["Yes", "No"]
                                }
                                onChange={handleRadioButtonChange}
                                name={item?.slug}
                                id={item?.id}
                                isRequired={item?.is_mandatory}
                                errId={`${item?.slug}-${item?.id}`}
                              />
                            </div>
                          </>
                        );
                      }
                      if (item?.input_type == 3 && item?.is_visible == "1") {
                        return (
                          <div
                            className="col-lg-10 col-md-12 col-sm-12 mb-3"
                            style={{
                              padding: 10,
                              gap: 10,
                              borderRadius: 8,
                              background: "#FFFAEB",
                            }}
                          >
                            <Checkbox
                              label={item?.label}
                              checked={item?.value}
                              value={item?.value}
                              onChange={handleCheckboxChange}
                              name={item?.slug}
                              id={item?.id}
                              isRequired={item?.is_mandatory}
                              errId={`${item?.slug}-${item?.id}`}
                              isDisabled={item?.slug == 'form2_partA_no_family'}
                            />
                            <p className="err text-danger" id={`${item?.slug}-${item?.id}`}></p>
                          </div>
                        );
                      }
                    })}
                  </div>
                  {/* <div className="border-top pb-2 pt-1"></div> */}
                  {key == "PF Nominee Details" ? (
                    <>
                      {/* <h1 className="tabsContentHead">
                        PF Nominee Details
                      </h1> */}

                      {nominees.map((nominee, index) => (
                        <div
                          key={nominee.id}
                          className="pfNominee border p-3 mt-2"
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <h1 className="tabsContentHead">
                              Nominee {index + 1}
                            </h1>
                            {nominees.length > 1 &&
                              index === nominees.length - 1 && (
                                <button
                                  className="btn btn-outline-light border-0 text-danger"
                                  style={{
                                    fontSize: 20,
                                    fontWeight: "bold",
                                  }}
                                  onClick={() => handleRemoveNominee(index)}
                                >
                                  X
                                </button>
                              )}
                          </div>

                          {/* Nominee Details */}
                          <div className="row mr-2 ml-2">
                            <div className="d-flex row pb-4 pt-4">
                              {nominee &&
                                Object.values(nominee).map((val, idx) => {
                                  // textField
                                  if (
                                    val.input_type == 1 &&
                                    val?.is_visible == "1"
                                  ) {
                                    console.log(val?.label, "nominee");
                                    return (
                                      <>
                                        <TextField
                                          label={val?.label}
                                          name={val?.slug}
                                          // key={`${val?.id}-${index}`}
                                          id={`${val?.id}-${index}-${idx}`}
                                          fieldId="spouseNameField"
                                          isRequired={val?.is_mandatory}
                                          // errId="spouseNameError"
                                          caseId={caseCheckId}
                                          divClass="col-lg-4 col-md-6 col-sm-12"
                                          value={val?.value}
                                          caseCheckId={caseCheckId}
                                          drugIndex={index}
                                          checkDetailsIndex={index}
                                          fieldName="spouseName"
                                          customError={false}
                                          isDisabled={allDisabled}
                                          index={index}
                                          collegeOther={otherInstituteObj}
                                          inputText={textHandler}
                                          labelStyle={{ color: "#6B7280" }}
                                          errId={`${val?.slug}-${val?.id}-${index}`}
                                          nomineeIndex={index}
                                          nomineeFieldIdx={idx}
                                        />
                                      </>
                                    );
                                  }
                                  // dropdown
                                  if (
                                    val.input_type == 4 &&
                                    val?.is_visible == "1"
                                  ) {
                                    return (
                                      <div className="col-lg-4 col-md-6 col-sm-12">
                                        <QualificationDropdown
                                          // label="Marital Status"
                                          label={val?.label}
                                          labelStyle={{ color: "#6B7280" }}
                                          key={`${val?.id}-${index}`}
                                          // options={["Married", "Single", "Divorced", "Widowed", "Separated", "Other"]}
                                          options={val.options}
                                          onChange={handleDropdownChange}
                                          errId={`${val?.slug}-${val?.id}-${index}`}
                                          name={val?.slug}
                                          value={val?.value}
                                          id={`${val?.id}-${index}`}
                                          isRequired={
                                            val?.is_mandatory == "1"
                                              ? true
                                              : false
                                          }
                                          nomineeIndex={index}
                                          nomineeFieldIdx={idx}
                                        />
                                      </div>
                                    );
                                  }
                                  // date field
                                  if (
                                    val.input_type == 7 &&
                                    val?.is_visible == "1"
                                  ) {
                                    return (
                                      <EMPDate
                                        placeholder={val?.label}
                                        name={val?.slug}
                                        id={`${val?.id}-${index}`}
                                        key={`${val?.id}-${index}`}
                                        fieldValue={val?.value}
                                        fieldId="dateOfJoiningField"
                                        paramStartDate=""
                                        checkDetailsIndex={index}
                                        fieldName="company_date_joining"
                                        fieldType='Onboarding'
                                        // errId="dateOfJoiningError"
                                        isRequired={
                                          val?.is_mandatory == "1"
                                            ? true
                                            : false
                                        }
                                        saveDate={saveDateHandler}
                                        isDisabled={allDisabled}
                                        checkID={58} // Example checkID, adjust according to your logic
                                        minDateDOL={null}
                                        maxDOJDate={null}
                                        divClass="col-lg-4 col-md-6 col-sm-12"
                                        placeholderStyle={{
                                          color: "#6B7280",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                        }}
                                        errId={`${val?.slug}-${val?.id}-${index}`}
                                        customError={false}
                                        nomineeIndex={index}
                                        nomineeFieldIdx={idx}
                                      />
                                    );
                                  }
                                  // Radio button
                                  if (
                                    val.input_type == 5 &&
                                    val?.is_visible == "1"
                                  ) {
                                    return (
                                      <>
                                        <div className="col-12 mb-4">
                                          <div
                                            className="d-flex"
                                            style={{ alignItems: "center" }}
                                          >
                                            <h1 className="tabsContentHead">
                                              {val?.label}
                                            </h1>
                                            {val?.is_mandatory == 1 && (
                                              <sup className="text-danger">
                                                {" "}
                                                *
                                              </sup>
                                            )}
                                          </div>

                                          <RadioButtonGroup
                                            options={
                                              Object.entries(val.options).map(
                                                ([key, value]) => {
                                                  return value;
                                                }
                                              ) || ["Yes", "No"]
                                            }
                                            key={`${val?.id}-${index}`}
                                            onChange={handleRadioButtonChange}
                                            name={val?.slug}
                                            id={`${val?.id}-${index}`}
                                            isRequired={val?.is_mandatory}
                                            errId={`${val?.slug}-${val?.id}-${index}`}
                                            nomineeIndex={index}
                                            nomineeFieldIdx={idx}
                                          />
                                        </div>
                                      </>
                                    );
                                  }
                                })}
                            </div>
                          </div>
                        </div>
                      ))}

                      <div className="d-flex justify-content-center">
                        <button
                          type="button"
                          className="btn"
                          onClick={handleAddNominee}
                          disabled={nominees.length >= 2}
                          style={{
                            width: 140,
                            height: 44,
                            position: "relative",
                            bottom: "20px",
                            background: "#1E429F",
                            fontSize: "12px",
                            fontWeight: "500",
                            lineHeight: "18px",
                            color: "white",
                          }}
                        >
                          <span style={{ fontSize: "18px", fontWeight: "800" }}>
                            +{" "}
                          </span>{" "}
                          Add Nominee
                        </button>
                      </div>
                      <div className="d-flex justify-content-center">
                        <span
                          style={{
                            width: "100%",
                            // height: 44,
                            position: "relative",
                            bottom: "20px",
                            fontSize: "12px",
                            fontWeight: "500",
                            lineHeight: "18px",
                            textAlign: "center",
                          }}
                          className="tabsContentSubHead"
                        >
                          *You may add 1 more nominee.
                        </span>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              );
            })}
        </div>
        <div className="d-flex justify-content-start align-items-center my-5 pt-4">
          <button
            className="btn font-weight-bold btn-outline-light text-dark border mr-3"
            disabled={prevTab ? false : true}
            onClick={handleBack}
          >
            Back
          </button>
          <button
            className="btn font-weight-bold btn-primary"
            onClick={saveHandler}
          >
            Save
          </button>
        </div>

        {showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}

        {/* </> */}
        {/* <div className='row my-3'> 
     {EpfData && EpfData.map((val,index)=>{
      if(val.input_type == 1){
      return (
        <>
          <ABTextEdu
            label={val?.label}
            name={val?.slug}
            id="spouseName"
            fieldId="spouseNameField"
            isRequired={1}
            errId="spouseNameError"
            caseId={caseCheckId}
            divClass="col-lg-4 col-md-6 col-sm-12"
            value={val[val?.slug] || ""}
            caseCheckId={caseCheckId}
            drugIndex={index}
            checkDetailsIndex={index}
            fieldName="spouseName"
            customError={false}
            isDisabled={allDisabled}
            index={index}
            collegeOther={otherInstituteObj}
            inputText={textHandler}
            labelStyle={{ color: '#6B7280' }}
          />
        </>
      )
    } 
    if(val.input_type == 4){
      return(
        <div className='col-lg-4 col-md-6 col-sm-12'>
      <QualificationDropdown
                label="Marital Status"
                labelStyle={{ color: '#6B7280' }}
                options={["Married", "Single", "Divorced", "Widowed", "Separated", "Other"]}
                onChange={handleDropdownChange}
              />
              </div>
      )
    }
    })}
    </div> */}
      </>
      <div className="py-3 d-none">
        <h1 className="tabsContentHead">Form 2 (Part A)</h1>
        <p className="tabsContentSubHead">
          Form 11 in EPFO (Employees' Provident Fund Organization) is a
          self-declaration form that individuals need to fill when joining an
          organization covered under the EPF Scheme, 1952 and/or EPS, 1995.
        </p>

        <div className="initialDetails border-bottom my-3 mt-4">
          {/* Row 1 */}
          <div className="row">
            <ABTextEdu
              label="Employee ID"
              name="employeeId"
              id="employeeId"
              fieldId="employeeIdField"
              isRequired={1}
              errId="employeeIdError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="employeeId"
              customError={false}
              isDisabled={allDisabled}
              inputText={textHandler}
              labelStyle={{ color: "#6B7280" }}
            />
            <ABTextEdu
              label="Nationality"
              name="nationality"
              id="nationality"
              fieldId="nationalityField"
              isRequired={1}
              errId="nationalityError"
              caseId={caseCheckId}
              divClass="col-lg-4 col-md-6 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="nationality"
              customError={false}
              isDisabled={allDisabled}
              inputText={textHandler}
              labelStyle={{ color: "#6B7280" }}
            />
          </div>

          {/* Row 2 */}
          <div className="row">
            <ABTextEdu
              label="Current Address"
              name="currentAddress"
              id="currentAddress"
              fieldId="currentAddressField"
              isRequired={1}
              errId="currentAddressError"
              caseId={caseCheckId}
              divClass="col-lg-12 col-md-12 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="currentAddress"
              customError={false}
              isDisabled={allDisabled}
              inputText={textHandler}
              labelStyle={{ color: "#6B7280" }}
            />
          </div>

          {/* Row 3 */}
          <div className="row">
            <ABTextEdu
              label="Permanent Address"
              name="permanentAddress"
              id="permanentAddress"
              fieldId="permanentAddressField"
              isRequired={1}
              errId="permanentAddressError"
              caseId={caseCheckId}
              divClass="col-lg-12 col-md-12 col-sm-12"
              value=""
              caseCheckId={caseCheckId}
              drugIndex={index}
              checkDetailsIndex={index}
              fieldName="permanentAddress"
              customError={false}
              isDisabled={allDisabled}
              inputText={textHandler}
              labelStyle={{ color: "#6B7280" }}
            />
          </div>
        </div>

        <div className="epf border-bottom my-3">
          <h1 className="tabsContentHead">PART-A (EPF)</h1>

          <div
            className="col-lg-10 col-md-12 col-sm-12 mb-3"
            style={{
              padding: 10,
              gap: 10,
              borderRadius: 8,
              background: "#FFFAEB",
            }}
          >
            <Checkbox
              label="I hereby nominate the person(s)/cancel the nomination made by me previously and nominate the person(s), mentioned below to receive the amount standing to my credit in the Employees’ Provident Fund, in the event of my death."
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
          </div>

          {/* <h1 className='tabsContentHead'>PF Nominee Details</h1> */}

          {/* {nominees.map((nominee, index) => (
          <div key={nominee.id} className="pfNominee border p-3 mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <h1 className='tabsContentHead'>Nominee {index + 1}</h1>
              {nominees.length > 1 && index === nominees.length - 1 && (
                <button
                  className="btn btn-outline-light border-0 text-danger"
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                  }}
                  onClick={() => handleRemoveNominee(nominees[nominees.length - 1].id)}
                >
                  X
                </button>
              )}
            </div>

            {/* Nominee Details */}
          {/* <div className="row">
              <ABTextEdu
                label="Name of Nominee"
                name={`nomineeName${nominee.id}`}
                id={`nomineeName${nominee.id}`}
                fieldId={`nomineeNameField${nominee.id}`}
                isRequired={1}
                errId={`nomineeNameError${nominee.id}`}
                caseId={caseCheckId}
                divClass="col-lg-4 col-md-6 col-sm-12"
                value=""
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName={`nomineeName${nominee.id}`}
                customError={false}
                isDisabled={allDisabled}
                inputText={textHandler}
                labelStyle={{ color: '#6B7280' }}
                onChange={(e) => handleInputChange(index, 'name', e.target.value)}
              />
              <ABTextEdu
                label="Relationship"
                name={`relationship${nominee.id}`}
                id={`relationship${nominee.id}`}
                fieldId={`relationshipField${nominee.id}`}
                isRequired={1}
                errId={`relationshipError${nominee.id}`}
                caseId={caseCheckId}
                divClass="col-lg-4 col-md-6 col-sm-12"
                value=""
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName={`relationship${nominee.id}`}
                customError={false}
                isDisabled={allDisabled}
                inputText={textHandler}
                labelStyle={{ color: '#6B7280' }}
                onChange={(e) => handleInputChange(index, 'relationship', e.target.value)}
              />
              <EMPDate
                placeholder="Date of Birth"
                name={`dob${nominee.id}`}
                id={`dob${nominee.id}`}
                fieldId={`dobField${nominee.id}`}
                isRequired={1}
                errId={`dobError${nominee.id}`}
                caseId={caseCheckId}
                divClass="col-lg-4 col-md-6 col-sm-12"
                value=""
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName={`dob${nominee.id}`}
                customError={false}
                isDisabled={allDisabled}
                inputText={textHandler}
                placeholderStyle={{ color: '#6B7280' }}
                onChange={(e) => handleInputChange(index, 'dob', e.target.value)}
              />
              <ABTextEdu
                label="Address"
                name={`address${nominee.id}`}
                id={`address${nominee.id}`}
                fieldId={`addressField${nominee.id}`}
                isRequired={1}
                errId={`addressError${nominee.id}`}
                caseId={caseCheckId}
                divClass="col-lg-12 col-md-12 col-sm-12"
                value=""
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName={`address${nominee.id}`}
                customError={false}
                isDisabled={allDisabled}
                inputText={textHandler}
                labelStyle={{ color: '#6B7280' }}
                onChange={(e) => handleInputChange(index, 'address', e.target.value)}
              />
              <ABTextEdu
                label="Share in Percentage"
                name={`sharePercentage${nominee.id}`}
                id={`sharePercentage${nominee.id}`}
                fieldId={`sharePercentageField${nominee.id}`}
                isRequired={1}
                errId={`sharePercentageError${nominee.id}`}
                caseId={caseCheckId}
                divClass="col-lg-4 col-md-6 col-sm-12"
                value=""
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName={`sharePercentage${nominee.id}`}
                customError={false}
                isDisabled={allDisabled}
                inputText={textHandler}
                labelStyle={{ color: '#6B7280' }}
                onChange={(e) => handleInputChange(index, 'sharePercentage', e.target.value)}
              />
            </div> */}

          {/* Guardian Details */}
          {/* <p style={{
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              textAlign: 'left',
              color: '#1D2939',
            }}>
              Guardian Detail (In case nominee is minor)
            </p>
            <div className="row">
              <ABTextEdu
                label="Name of Guardian"
                name={`guardianName${nominee.id}`}
                id={`guardianName${nominee.id}`}
                fieldId={`guardianNameField${nominee.id}`}
                isRequired={1}
                errId={`guardianNameError${nominee.id}`}
                caseId={caseCheckId}
                divClass="col-lg-4 col-md-6 col-sm-12"
                value=""
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName={`guardianName${nominee.id}`}
                customError={false}
                isDisabled={allDisabled}
                inputText={textHandler}
                labelStyle={{ color: '#6B7280' }}
                onChange={(e) => handleInputChange(index, 'guardianName', e.target.value)}
              />
              <ABTextEdu
                label="Address"
                name={`guardianAddress${nominee.id}`}
                id={`guardianAddress${nominee.id}`}
                fieldId={`guardianAddressField${nominee.id}`}
                isRequired={1}
                errId={`guardianAddressError${nominee.id}`}
                caseId={caseCheckId}
                divClass="col-lg-12 col-md-12 col-sm-12"
                value=""
                caseCheckId={caseCheckId}
                drugIndex={index}
                checkDetailsIndex={index}
                fieldName={`guardianAddress${nominee.id}`}
                customError={false}
                isDisabled={allDisabled}
                inputText={textHandler}
                labelStyle={{ color: '#6B7280' }}
                onChange={(e) => handleInputChange(index, 'guardianAddress', e.target.value)}
              />
            </div> */}
          {/* </div> */}
          {/* ))} */}

          {/* <div className="d-flex justify-content-center">
          <button
            type='button'
            className="btn"
            onClick={handleAddNominee}
            disabled={nominees.length >= 8}
            style={{
              width: 140,
              height: 44,
              position: "relative",
              bottom: "-40px",
              background: "#1E429F",
              fontSize: "12px",
              fontWeight: "500",
              lineHeight: "18px",
              color: "white",
            }}
          >
            <span style={{ fontSize: "18px", fontWeight: "800"}}>+ </span> Add Nominee
          </button>
        </div>
        <div className="d-flex justify-content-center">
          <span
            style={{
              width: "100%",
              // height: 44,
              position: "relative",
              bottom: "-40px",
              fontSize: "12px",
              fontWeight: "500",
              lineHeight: "18px",
              textAlign: "center",
            }}
            className='tabsContentSubHead'
          >
            *You may add upto 4 nominee's
          </span>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default Form2PartA;
